import { render } from "./Auth.vue?vue&type=template&id=6d9e84fa"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"

import "./Auth.vue?vue&type=style&index=0&id=6d9e84fa&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__